import React from 'react';
import { Image, Text } from 'react-native';
import { View } from 'react-native-web';
import {
  getSubCategoryId, QR_not_valid,
} from '../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../FullPageSimulator';
import { barcode_scan } from '../../../../utils/ImagesManagementUtils';
import {
  textLink_13_0,
  textPrimary_11_0,
  textPrimary_13_0,
} from '../../AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================
const PayBillsScanBarcodeFP = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
  showPopup,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { select_bill } = globJSON.configurations.services[subCategoryId];
  const myStyles = {
    container: {
      height: 110,
      width: 212,
      paddingHorizontal: 10,
      paddingVertical: 16,
      marginHorizontal: 14,
      marginVertical: 72,
      position: 'absolute',
      backgroundColor: 'white',
    },
    barcode: {
      height: 254,
      width: 240,
    },
    invalidQR: {
      marginBottom: 10,
    },
    notValidQR: {
      marginBottom: 24,
    },
    tryAgain: {
      textAlign: 'right',
    },
  };

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={select_bill.scan_bill_barcode}
      slideshowRefs={slideshowRefs}
    >
      <Image
        fadeDuration={0}
        style={myStyles.barcode}
        source={barcode_scan}
      />
      {showPopup && (
      <View style={myStyles.container}>
        <Text style={[textPrimary_13_0(globJSON, simPlatform), myStyles.invalidQR]}>{select_bill.invalid_qr}</Text>
        <Text style={[textPrimary_11_0(globJSON, simPlatform), myStyles.notValidQR]}>{QR_not_valid}</Text>
        <Text style={[textLink_13_0(globJSON, simPlatform), myStyles.tryAgain]}>{select_bill.try_again}</Text>
      </View>
      )}
    </FullPageSimulator>
  );
};

export default PayBillsScanBarcodeFP;
